import React from 'react';
class Error extends React.Component {
    render() {
        return (
            <div>
                <p>Error: Path does not exist!!</p>
            </div>
        );
    }
}

export default Error;
